import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-toolbar',
    imports: [RouterLink, MatIconModule, MatMenuModule, MatDividerModule, MatButtonModule],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent {
    authService = inject(AuthService);
    isAuthLoading = toSignal(this.authService.isLoading$);
    user = toSignal(this.authService.user$);
    http = inject(HttpClient);

    onLogout() {
        this.authService.logout({ logoutParams: { returnTo: window.location.origin } });
    }

    onGoToOverview() {
        window.open(environment.overviewAppUrl, '_blank');
    }

    onLogin() {
        this.authService.loginWithRedirect();
    }
}
